module.exports = __webpack_public_path__ + "img/company1-2.ad0e274e.jpg";